import { ErrorHandler } from '@angular/core';
// Perfect Scroll bar
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
// Env
import { environment } from '../environments/environment';
// Hammer JS
import 'hammerjs';
// Config
import { configLoader } from './core/config';
// Layout Services
import { LayoutConfigService } from './core/_base/layout';
// Config
import { LayoutConfig } from './core/_config/layout.config';
// Highlight JS
import { HighlightLanguage } from 'ngx-highlightjs';
import * as typescript from 'highlight.js/lib/languages/typescript';
import * as scss from 'highlight.js/lib/languages/scss';
import * as xml from 'highlight.js/lib/languages/xml';
import * as json from 'highlight.js/lib/languages/json';
// tslint:disable-next-line:class-name
var DEFAULT_PERFECT_SCROLLBAR_CONFIG = {
    wheelSpeed: 0.5,
    swipeEasing: true,
    minScrollbarLength: 40,
    maxScrollbarLength: 300,
};
import * as Sentry from "@sentry/angular";
export function initializeLayoutConfig(appConfig) {
    // initialize app by loading default demo layout config
    return function () {
        if (appConfig.getConfig() === null) {
            appConfig.loadConfigs(new LayoutConfig().configs);
        }
    };
}
export function hljsLanguages() {
    return [
        { name: 'typescript', func: typescript },
        { name: 'scss', func: scss },
        { name: 'xml', func: xml },
        { name: 'json', func: json }
    ];
}
var ɵ0 = DEFAULT_PERFECT_SCROLLBAR_CONFIG, ɵ1 = configLoader, ɵ2 = { languages: hljsLanguages }, ɵ3 = function () {
    // Only use Sentry error handler in production builds; keep console logging enabled
    return environment.production
        ? Sentry.createErrorHandler({ logErrors: true })
        : new ErrorHandler();
};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
